import actions from "./actions";
import {setRequestReducer, setSuccessReducer} from "../helper";

const initState = {
    priceLevelCreateState: false,
    priceLevelCreateResult: {},

    priceLevelReadAllState: false,

    priceLevels: [],
    pagination: {},

    priceLevelUpdateState: false,
    priceLevelUpdateResult: {},

    priceLevelArchiveState: false,
    priceLevelArchiveResult: {},

    priceLevelDeleteState: false,

    priceLevelReadState: false,
    priceLevel: false,
    priceLevelDrawerVisible: false,
    priceLevelDrawerMode: undefined, // 'create', 'update'
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.PRICE_LEVEL_CREATE_REQUEST:
            return setRequestReducer(state, 'priceLevelCreateState');
        case actions.PRICE_LEVEL_CREATE_SUCCESS:
            return setSuccessReducer(state, 'priceLevelCreateState', {
                priceLevelCreateResult: action.priceLevel,
            });

        case actions.PRICE_LEVEL_READ_ALL_REQUEST:
            return setRequestReducer(state, 'priceLevelReadAllState');
        case actions.PRICE_LEVEL_READ_ALL_SUCCESS:
            return setSuccessReducer(state, 'priceLevelReadAllState', {
                priceLevels: action.priceLevels,
                pagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            });

        case actions.PRICE_LEVEL_READ_REQUEST:
            return setRequestReducer(state, 'priceLevelReadState');
        case actions.PRICE_LEVEL_READ_SUCCESS:
            return setSuccessReducer(state, 'priceLevelReadState', {
                priceLevel: action.priceLevel,
            });

        case actions.PRICE_LEVEL_UPDATE_REQUEST:
            return setRequestReducer(state, 'priceLevelUpdateState');
        case actions.PRICE_LEVEL_UPDATE_SUCCESS:
            return setSuccessReducer(state, 'priceLevelUpdateState');

        case actions.PRICE_LEVEL_ARCHIVE_REQUEST:
            return setRequestReducer(state, 'priceLevelArchiveState');
        case actions.PRICE_LEVEL_ARCHIVE_SUCCESS:
            return setSuccessReducer(state, 'priceLevelArchiveState');

        case actions.PRICE_LEVEL_DELETE_REQUEST:
            return setRequestReducer(state, 'priceLevelDeleteState');
        case actions.PRICE_LEVEL_DELETE_SUCCESS:
            return setSuccessReducer(state, 'priceLevelDeleteState');

        case actions.PRICE_LEVEL_CHANGE: { // Partial update
            const priceLevel = {
                ...(action.reset ? initState.priceLevel : state.priceLevel),
                ...action.request,
            };

            return {
                ...state,
                priceLevel,
            };
        }
        case actions.PRICE_LEVEL_TOGGLE_DRAWER:
            return {
                ...state,
                priceLevelDrawerVisible: action.visible,
                priceLevelDrawerMode: action.mode,
            };

        case actions.PRICE_LEVEL_RESET_STATE:
            return {
                ...initState,
            };
        default:
            return state;
    }
}
